import { useContext } from "react";
import type { AxiosInstance } from "axios";

import { AxiosContext } from "../contexts/axios/AxiosContext";

export const useAxios = (): AxiosInstance => {
  return useContext(AxiosContext);
};
